var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useAsyncAction } from "nate-react-api-helpers";
import { api } from "../../api/API";
import { TTimePicker } from "../TTimePicker";
import Switch from "@mui/material/Switch";
import { MechanicShiftContext } from "./MechanicShiftContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function EndShift(props) {
    var _this = this;
    var _a = useState(null), start = _a[0], setStart = _a[1];
    var _b = useState(null), end = _b[0], setEnd = _b[1];
    var _c = useState(false), lunch = _c[0], setLunch = _c[1];
    var _d = useContext(MechanicShiftContext), current = _d.current, reload = _d.reload;
    var r = current;
    useEffect(function () { if (!r)
        return; setStart(new Date(r.startTime)); setEnd(new Date()); }, [r]);
    var onCloseRef = useRef(props.onClose);
    onCloseRef.current = props.onClose;
    var endShift = useAsyncAction(function (input) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, api.tracking.endShift(input)];
            case 1:
                _a.sent();
                reload();
                onCloseRef.current();
                return [2 /*return*/];
        }
    }); }); }, []);
    return /*#__PURE__*/ _jsxs(Dialog, { open: true, onClose: function () { return props.onClose(); }, children: [/*#__PURE__*/ _jsx(DialogTitle, { children: "End Shift" }), /*#__PURE__*/ _jsxs(DialogContent, { children: [/*#__PURE__*/ _jsxs("div", { style: { display: "flex" }, children: [/*#__PURE__*/ _jsx(TTimePicker, { label: "Start", value: start, variant: "inline", onChange: setStart }), /*#__PURE__*/ _jsx("div", { style: { width: 8 } }), /*#__PURE__*/ _jsx(TTimePicker, { label: "End", value: end, variant: "inline", onChange: setEnd })] }), /*#__PURE__*/ _jsx("div", { style: { height: 16 } }), /*#__PURE__*/ _jsxs("div", { style: { display: "flex", alignItems: "center" }, children: [/*#__PURE__*/ _jsx(Switch, { checked: lunch, onChange: function (e) { return setLunch(e.target.checked); } }), /*#__PURE__*/ _jsx("div", { style: { paddingLeft: 16 }, children: "Includes lunch break" })] })] }), /*#__PURE__*/ _jsxs(DialogActions, { children: [endShift.LoadingElement, /*#__PURE__*/ _jsx(Button, { onClick: function () { return props.onClose(); }, children: "Cancel" }), /*#__PURE__*/ _jsx(Button, { onClick: function () { if (!start)
                            return; if (!end)
                            return; endShift.callback({ startedAt: start.toJSON(), endedAt: end.toJSON(), lunch: lunch }); }, children: "End Shift" })] })] });
}
